import React, { useEffect, useState } from "react";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import List from "../../../components/List/List";
import Loader from "../../../components/Loader/Loader";
import { useParams } from "react-router-dom";

const ViewRoutineGroup = () => {
  const {
    day,
    enrollmentSetupId,
    routinePeriodId,
    programId,
    semesterId,
    curriculumSectionMapId,
  } = useParams();
  const headers = ["Subject", "Faculty", "Start Time", "End Time"];
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await adminRequest.post(
        `${BASE_URL}/routine/group/details`,
        {
          day,
          enrollmentSetupId,
          routinePeriodId,
          program: programId,
          semester: semesterId,
          curriculumSectionMapId,
        }
      );
      const fetchedRows = response.data.data.map((e) => ({
        displayData: [
          e.subject,
          e.faculty.name,
          e.timeSlot.startTime,
          e.timeSlot.endTime,
        ],
        program: e.program.short_name,
        semester: e.semester.semester,
        section: e.section.name,
        uuid: e.uuid,
        day: e.day,
      }));
      setRows(fetchedRows);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getMenuItems = (row) => [
    { link: `/setup/routine/edit/${row.uuid}`, text: "Edit" },
  ];

  return (
    <div className="facultyCategoryListContainer">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <List
            title={
              rows.length > 0
                ? `Routine Details (${rows[0].program}, ${rows[0].semester}, ${rows[0].section})`
                : "Routine Details"
            }
            createButtonLabel="Edit Routine Group"
            showCreateButtonLabel={false}
            headers={headers}
            rows={rows.map((row) => row.displayData)}
            link="#"
            showEyeViewIcon={false}
            showFilterIcon={false}
            getMenuItems={(row) =>
              getMenuItems(rows.find((r) => r.displayData === row))
            }
          />
        </>
      )}
    </div>
  );
};

export default ViewRoutineGroup;
